export type IncomeSelectFormField = {
  type: 'select'
  options: { value: string, label: string }[]
};

export type IncomeNumericFormField = {
  type: 'numeric'
  currency?: boolean
};

export type IncomeTextFormField = {
  type: 'text'
};

type IncomeFormFieldType = IncomeSelectFormField | IncomeNumericFormField | IncomeTextFormField;

export type IncomeFormField = {
  id: string
  label: string
  placeholder: string
  visible?: (form: Record<string, string>) => boolean;
  initialValue?: string
  validation?: {
    rules: string
    messages?: Record<string, string>
  }
} & IncomeFormFieldType;

const BANCO_BOGOTA_ECONOMIC_OPTIONS = [
  { value: 'asalariado', label: 'Asalariado' },
  { value: 'pensionado', label: 'Pensionado' },
  { value: 'comerciante', label: 'Comerciante' },
  { value: 'agropecuario', label: 'Agropecuario' },
  { value: 'manufactura', label: 'Manufactura' },
  { value: 'rentista', label: 'Rentista de Capital' },
  { value: 'servicios', label: 'Servicios' },
  { value: 'transportador', label: 'Transportador' },
  { value: 'independiente', label: 'Profesional Independiente' },
  { value: 'otros', label: 'Otras actividades de servicios personales  n.c.p' },
];

const BANCO_BOGOTA_EXTRA_ECONOMIC_OPTIONS = [
  ...BANCO_BOGOTA_ECONOMIC_OPTIONS,
  { value: 'ninguna', label: 'Ninguna' },
];

export const GENERIC_ECONOMIC_OPTIONS = [
  { value: 'entretenimiento', label: 'Entretenimiento, actividades artísticas o culturales.' },
  { value: 'alojamiento', label: 'Alojamiento y servicios de comida' },
  { value: 'transporte', label: 'Transporte (terrestre, aéreo, Marítimo ) y almacenamiento' },
  { value: 'comercio', label: 'Comercio y reparación de vehículos' },
  { value: 'construccion', label: 'Construcción y Bienes Raíces' },
  { value: 'industria', label: 'Industria manufacturera' },
  { value: 'servicios', label: 'Servicios Financieros y de seguros' },
  { value: 'educacion', label: 'Educación' },
  { value: 'suministro', label: 'Suministro de gas, agua y manejo de basuras.' },
  { value: 'agricultura', label: 'Agricultura, ganadería.' },
  { value: 'informacion', label: 'Información y Comunicaciones' },
  { value: 'administracion', label: 'Administración pública (defensa, educación, salud).' },
  { value: 'actividades', label: 'Actividades profesionales, científicas y técnicas.' },
  { value: 'otro', label: 'Otro, ¿cuál?' },
];

export const BANCO_BOGOTA_QUESTIONS: IncomeFormField[] = [
  // {
  //   id: 'economic',
  //   label: 'Actividad económica',
  //   type: 'select',
  //   options: BANCO_BOGOTA_ECONOMIC_OPTIONS,
  //   placeholder: 'Seleccionar',
  //   initialValue: '',
  //   validation: {
  //     rules: 'required',
  //     messages: {
  //       'required.economic': 'Debes seleccionar una actividad económica',
  //     },
  //   },
  // },
  {
    id: 'salary',
    label: 'Salario / Pensión o Ingreso Bruto (sin descuentos)',
    type: 'numeric',
    currency: true,
    placeholder: '$ 0',
    validation: {
      rules: 'required',
      messages: {
        'required.salary': 'Debes indicar tu Salario / Pensión o Ingreso Bruto',
      },
    },
  },
  {
    id: 'monthlyPayments',
    label: 'Cuotas de Crédito Mensuales - Sector Financiero (No incluya cuota de crédito para este tramite)',
    type: 'numeric',
    currency: true,
    placeholder: '$ 0',
    validation: {
      rules: 'required',
      messages: {
        'required.monthlyPayments': 'Debes indicar tus Cuotas de Crédito Mensuales',
      },
    },
  },
  {
    id: 'extraIncomeEconomic',
    label: 'Actividad económica de los ingresos adicionales',
    type: 'select',
    options: BANCO_BOGOTA_EXTRA_ECONOMIC_OPTIONS,
    placeholder: 'Seleccionar',
    initialValue: '',
    validation: {
      rules: 'required',
      messages: {
        'required.extraIncomeEconomic': 'Debes seleccionar una actividad económica',
      },
    },
  },
  {
    id: 'extraIncome',
    label: 'Ingresos Adicionales',
    type: 'numeric',
    currency: true,
    placeholder: '$ 0',
    visible: ({ extraIncomeEconomic }) => extraIncomeEconomic !== 'ninguna',
    validation: {
      rules: 'required_unless:extraIncomeEconomic,ninguna',
      messages: {
        'required_unless.extraIncome': 'Debes indicar tus ingresos adicionales',
      },
    },
  },
];

export const GENERIC_QUESTIONS: IncomeFormField[] = [
  {
    id: 'economic',
    label: 'Sector económico en el que laboras / laboraste',
    type: 'select',
    options: GENERIC_ECONOMIC_OPTIONS,
    placeholder: 'Seleccionar sector',
    initialValue: '',
    validation: {
      rules: 'required',
      messages: {
        'required.economic': 'Debes seleccionar un sector económico',
      },
    },
  },
  {
    id: 'economicOther',
    label: '¿Cúal es el sector?',
    type: 'text',
    placeholder: 'Escribe el sector',
    visible: ({ economic }) => economic === 'otro',
    initialValue: '',
    validation: {
      rules: 'required_if:economic,otro',
      messages: {
        'required_if.economicOther': 'Debes escribir un sector económico',
      },
    },
  },
];
